import { createUseStyles, withTheme } from '@glu/theming';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './StyledSelect.styles.js';

const useStyles = createUseStyles(styles);

const StyledSelect = ({ children, ...rest }) => {
  const classes = useStyles(rest);

  return <div className={classes.wrapper}>{children}</div>;
};

StyledSelect.propTypes = {
  children: PropTypes.node.isRequired,
};

export default withTheme(StyledSelect);
